/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TextDisplay/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function TextDisplay({
  children,
  viewPath = "/DesignSystem/TasksViewForm/Content/Content/Activities/Content/Activity/ActivityType/Log/FromPart/TextDisplay"
  
}) {
let constantData = 'from'
let constantData1 = '‎'
let aggregateData = fromAggregate.join(constantData, constantData1)
let activityTextpartsFromValueData = fromData.useDataValue({ viewPath,
context: 'activity',
path: 'textParts.from',
})
let activityTextpartsNofromValueData = fromData.useDataValue({ viewPath,
context: 'activity',
path: 'textParts.noFrom',
})
let aggregateData1 = fromHelpers.showToPrefix(activityTextpartsFromValueData, activityTextpartsNofromValueData)
let dtTypographyFontsizeM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.m'
        })
let activityTextpartsFromValueData1 = fromData.useDataValue({ viewPath,
context: 'activity',
path: 'textParts.from',
})
let activityTextpartsFromValueData2 = fromData.useDataFormat({ viewPath,
context: 'activity',
path: 'textParts.from',
format: fromHelpers.truncate,
})
let constantData2 = '‎'
let aggregateData2 = fromAggregate.join(activityTextpartsFromValueData2, constantData2)
let activityTextpartsFromValueData3 = fromData.useDataValue({ viewPath,
context: 'activity',
path: 'textParts.from',
})
  return (<React.Fragment
>
<fromFlow.When is={aggregateData1}>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 display="inline"
 fontSize={dtTypographyFontsizeM}
 data="'from'"
 data="'‎'"
 aggregate="/Data/aggregate.js join"
 text={aggregateData}
 data="activity.textParts.from"
 data="activity.textParts.noFrom"
 aggregate="helpers.js showToPrefix"
/>
</fromFlow.When>
<fromFlow.When is={activityTextpartsFromValueData3}>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 backgroundColor="transparent"
 display="inline"
 weight="medium"
 fontSize={dtTypographyFontsizeM}
 data="activity.textParts.from"
 title={activityTextpartsFromValueData1}
 data="activity.textParts.from"
 format="helpers.js truncate"
 data="'‎'"
 aggregate="/Data/aggregate.js join"
 text={aggregateData2}
 data="activity.textParts.from"
/>
</fromFlow.When>
{children}
</React.Fragment>)
}